/**
 * Runtime config for Vitality Pedigree. Anything customer-facing that may
 * need to change without redeploying lives here, pulled from REACT_APP_* env.
 */
export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

// URL of your WooCommerce subscription product page. Update by editing
// /app/frontend/.env REACT_APP_SUBSCRIBE_URL and restarting the frontend.
export const SUBSCRIBE_URL =
  process.env.REACT_APP_SUBSCRIBE_URL ||
  "https://yankeecotons.com/product/health-focused-pedigree/";

export const APP_NAME = "Vitality Pedigree";
export const APP_TAGLINE = "Structure & Medical pedigrees for breeders.";
